import React from 'react';

export default {
  width: 16,
  height: 16,
  content: (
    <path d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm0-2A6 6 0 1 0 8 2a6 6 0 0 0 0 12z M9 7.954l1.805 2.453-1.61 1.186L7 8.61V4h2z" />
  )
};
